import { render } from "./Circle.vue?vue&type=template&id=cbb83abe&scoped=true"
const script = {}

import "./Circle.vue?vue&type=style&index=0&id=cbb83abe&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbb83abe"]])

export default __exports__